module.exports = __webpack_public_path__ + "static/media/grails.dd87d7cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grails.svg
// module id = 508
// module chunks = 0